module.exports = __webpack_public_path__ + "img/TG.c270b112.svg";